import { ChangeEvent, useCallback, useState } from "react";
import { useDebounce } from "react-use";

type useDebouncedSearchProps = {
  setDebouncedSearchInput: (searchInput: string) => void;
};
export const useDebouncedSearch = ({
  setDebouncedSearchInput,
}: useDebouncedSearchProps) => {
  const [searchInput, setSearchInput] = useState("");

  useDebounce(
    () => {
      setDebouncedSearchInput(searchInput);
    },
    1000,
    [searchInput],
  );

  const handleSearch = useCallback(() => {
    setDebouncedSearchInput(searchInput);
  }, [searchInput, setDebouncedSearchInput]);

  const handleSearchInputClear = () => {
    setSearchInput("");
    setDebouncedSearchInput("");
  };

  const handleSearchInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchInput(e.target.value);
  };

  return {
    searchInput,
    handleSearch,
    handleSearchInputClear,
    handleSearchInputChange,
  };
};
